import React from "react";
import "./Button.jsx";
import "./Button.scss";

const Button = ({ label, sublabel, status, clickFunction, isIcon=false, img, buttonType, freq, isRightIcon=false, loading=false }) => {
  return (
    <button
      className={status && !loading ? `${buttonType} active` : `${buttonType} disabled`}
      onClick={(e) => !loading && status && clickFunction(e)}
      disabled={loading || !status}
    >
      {loading ? (
        <div className="btn-spinner" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', padding: '0.2rem 2.2rem' }}>
          <i className="fa fa-spinner fa-spin" style={{ color: 'white' }}></i>
        </div>
      ) : (
        <>
          {isIcon ? (
            <div className="btn-inc">
              <img src={img} width="100%" height="100%" alt="arrow" title="arrow" />
            </div>
          ) : null}
          <div className="btn-txt">{label} </div>
          {
            buttonType === "premium-btn" || buttonType === "premium-btn-ar" ?
              <div className="btn-sub-txt">/ {freq}</div> : null
          }
          {isRightIcon ? (
            <div className="btn-rgt-inc">
              <img src={img} width="100%" height="100%" alt="arrow" title="arrow" />
            </div>
          ) : null}
        </>
      )}
    </button>
  );
};
export default Button;
